
import { useState, forwardRef, useCallback } from "react";
// import clsx from "clsx";

import { 
    Collapse,
    Paper,
    Typography,
    Card,
    CardActions,
    Button,
    IconButton,
    Box,
    List,
    ListItem,
    ListItemText,
    Chip,
    Badge,
    styled
} from "@mui/material";

import { green, grey, red, orange } from "@mui/material/colors";
// import clsx from "clsx";

// import { makeStyles } from "@mui/styles";
import { useSnackbar, SnackbarContent, CustomContentProps } from "notistack";
// import Collapse from "@mui/material/Collapse";
// import Paper from "@mui/material/Paper";
// import Typography from "@mui/material/Typography";
// import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
// import Button from "@mui/material/Button";
// import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { CommonIcons, icons } from "./CommonIcons"


// const useStyles = makeStyles(() => ({
const useStyles = {
  root: {
    "@media (minWidth:600px)": {
      minWidth: "444px !important"
    }
  },
  card: {
    width: "100%"
  },
  typography: {
    color: "#000"
  },
  actionRoot: {
    padding: "8px 8px 8px 16px",
    justifyContent: "space-between"
  },
  icons: {
    marginLeft: "auto"
  },
  expand: {
    padding: "8px 8px",
    transform: "rotate(0deg)",
    color: "#000",
    transition: "all .2s"
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  paper: {
    backgroundColor: "#fff",
    // padding: 16,
    // textAlign: 'left',
    // flex: 1,
    // justifyContent: 'flex-start',
    // alignItems: 'flex-start'
  },
  list: {
    backgroundColor: '#fff'
  },
  checkIcon: {
    fontSize: 20,
    paddingRight: 4
  },
  button: {
    padding: 0,
    textTransform: "none"
  }
// }));
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));


const CommonNotistack = forwardRef(
  ({ id, data, icon, ...props }, ref) => 
  {
    const classes = useStyles;
    const { closeSnackbar } = useSnackbar();
    const [expanded, setExpanded] = useState(false);

    const handleExpandClick = useCallback(() => {
      setExpanded((oldExpanded) => !oldExpanded);
    }, []);

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const RenderWarningSection = ({ title, message, status, index, count }) => {

        const RenderIcon = ({ status }) => {
          if(status === "success"){
            return <CommonIcons name={icons.success} sx={{ backgroundColor: green[400] }} />
          }
          if(status === "error"){
            return <CommonIcons name={icons.error} sx={{ backgroundColor: red[400] }} />
          }
          return <CommonIcons name={icons.info} sx={{ backgroundColor: orange[600] }} />
        }

        return (
            <ListItem
                // sx={{
                //     borderColor: '#e1e1e1',
                //     borderWidth: 1,
                //     borderStyle: 'solid',
                //     alignItems: 'flex-start'
                // }}
                disablePadding
                divider={
                    index < (count - 1)
                }
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-start',
                    alignItems: 'flex-start',
                    px: 1,
                    py: 1,
                    // borderColor: '#e1e1e1',
                    // borderWidth: 1,
                    // borderStyle: 'solid',
                }}
            >
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  sx={{
                    // borderColor: grey[300],
                    // borderWidth: 1,
                    // borderStyle: 'solid',
                    backgroundColor: grey[100],
                    borderRadius: 1,
                    width: '100%',
                    px: 1,
                    py: 0.5,
                    mb: 1
                  }}
                >
                  <RenderIcon status={status} />
                  <Typography
                    sx={{
                        alignSelf: 'center',
                        ml: 1,
                        fontSize: 14,
                        fontWeight: '500'
                    }}
                  >{title}
                  </Typography>
                </Box>
                <Box display={"block"} sx={{ fontSize: 12, px: 1 }}>
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                </Box>
            </ListItem>
        )

    }


    return (
      <SnackbarContent ref={ref} style={classes.root}>
        <Card sx={[classes.card, { backgroundColor: "#fddc6c" }]}>
          <CardActions classes={{ root: classes.actionRoot }}>
            {
                icon()
            }
            <Typography variant="body2" style={classes.typography}>

              {`${props?.message}`}
            </Typography>
            <div style={classes.icons}>
                <StyledBadge badgeContent={data.length} color="warning">
                    <IconButton
                        aria-label="Show more"
                        size="small"
                        // style={clsx(classes.expand, {
                        //   [classes.expandOpen]: expanded
                        // })}
                        sx={{ ml: 1 }}
                        onClick={handleExpandClick}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </StyledBadge>
                <IconButton
                    size="small"
                    sx={[classes.expand, { ml: 1 }]}
                    onClick={handleDismiss}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            {/* <Paper sx={classes.paper}> */}
            <Paper style={{maxHeight: 400, overflow: 'auto'}}>
                <List sx={classes.list}>
                    {
                        data.map((i, index) => {
                            return (
                                <RenderWarningSection
                                    key={index}
                                    title={i?.title}
                                    message={i.message}
                                    status={i.status}
                                    index={index}
                                    count={data.length}
                                />
                            )
                        })
                    }
                </List>
            </Paper>
          </Collapse>
        </Card>
      </SnackbarContent>
    );
  }
);


CommonNotistack.displayName = "ReportComplete";

export default CommonNotistack;

